module.exports = __webpack_public_path__ + "static/img/modal_bgkhm.b96068d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hongbao/img/modal_bgkhm.png
// module id = GESK
// module chunks = 1